import classNames from "classnames";
import React, { useContext } from "react";

import { EventContext } from "@gp/components";

import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";

export default function BettingTypeGroupHeader(props: {
	isExpanded?: boolean;
	onSetExpand: (newValue: boolean) => void;
	group: { abrv: string; name: string };
	isFavorite?: boolean;
}) {
	const { isExpanded, onSetExpand, group } = props;
	const event = useContext(EventContext);
	const store = useOfferContext<OfferStore.EventViewStore>();

	const eventKeys = store.eventKeysMap.get(event.id);

	if (eventKeys == null || eventKeys.size === 0) {
		return null;
	}

	const headerClasses = classNames("offer__header offer--additional__head", {
		"is-collapsed": !isExpanded,
	});

	const headerToggleClasses = classNames(
		"offer__toggle offer--additional__head__toggle btn btn--base btn--block",
		{
			"is-collapsed": !isExpanded,
		}
	);

	return (
		<h3 className={headerClasses} title={group.name}>
			<button
				type="button"
				className={headerToggleClasses}
				onClick={() => onSetExpand(!isExpanded)}
			>
				<span className="offer__title offer--additional__head__title">
					{group.name}
				</span>

				<span className="offer__actions">
					<span className="offer__actions__btn btn btn--icon btn--square btn--square--xtny btn--ghost">
						<i
							className={
								"u-icon u-icon--tny btn__icon" +
								(isExpanded
									? " u-icon--caret--up"
									: " u-icon--caret--down")
							}
						/>
					</span>
				</span>
			</button>
		</h3>
	);
}
